export async function injectTagManager(onlyEtracker: boolean = false) {
  let url = '/en/?type=1553774374';
  if (window.location.hostname === 'faulhaber.com.cn') {
    url = '/主页/?type=1553774374';
  }
  let userType = sessionStorage.getItem('dataLayer__userType') || '';
  let gaProperties: {[key: string]: string} = JSON.parse(sessionStorage.getItem('dataLayer__gaProperties') || '[]');
  const gaKeys = Object.keys(gaProperties);
  if (!userType || gaKeys.length === 0) {
    const resultData = await $.ajax(url);
    userType = resultData.userType;
    gaProperties = resultData.gaProperties;
    sessionStorage.setItem('dataLayer__userType', userType);
    sessionStorage.setItem('dataLayer__gaProperties', JSON.stringify(gaProperties));
  }

  (<any>window).dataLayer = [
    {
      event: 'userInfo',
      userType: userType,
    },
  ];

  const isTest = window.location.hostname.includes('wwwserver.net') || window.location.hostname.includes('iveins.de');
  if (onlyEtracker && !isTest) {
    gaProperties = {'GTM-TQVTQ63': gaKeys['GTM-TQVTQ63'] || ''};
  }

  Object.keys(gaProperties).forEach((gaProperty) => {
    // prevent duplications if code is called twice
    // if (document.querySelector('[src*="' + gaProperty + '"]')) {
    //   return;
    // }

    /* tslint:disable */
    (function (w, d, s: 'script', l, i) {
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      const f: any = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = (l != 'dataLayer' ? '&l=' + l : '');
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + gaProperties[gaProperty] ?? '';
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', gaProperty);
    /* tslint:enable */
  });
}
